export const getFormattedLength = (length: number) => {
    const formattedLength = (length / 1000).toString().split('')
    formattedLength.splice(1, 1);
    return formattedLength.join('');
};